<template>
  <b-card no-body style="border: none; height: 100%; margin: 0;">
    <b-table responsive id="my-table" :items="tableData"
             tbody-tr-class="test"
             :fields="fields"
             class="custom-auto-height">
      <template v-slot:cell(count_open)="data">
        <checkmark
            title=""
            v-tooltip="'Vergeben'"
            class="icon-1_5x icon-def-green" fillColor="#383838" :size="72" ></checkmark>
      </template>
      <template v-slot:cell(completed)="data">
        <div style="display: flex;
    flex-direction: row;" >
          <checkmark
              v-if="data.item.offen === 1"
              title=""
              v-tooltip="'Fertig'"
              class="icon-1_5x" style="margin-top: -1px; color: #027a02" fillColor="#027a02" :size="72"></checkmark>
          <span :style="data.item.offen === 1 ? 'padding-top: 3px; margin-left: 3px; color: green;' : 'padding-top: 3px; margin-left: 3px'"><b>{{data.item.offen == 1 ? '1/1' : '0/1'}}</b></span>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import CurrencyEurIcon from 'vue-material-design-icons/CurrencyEur.vue';
import CloseCircleIcon from 'vue-material-design-icons/CloseCircle';
import CircleYearIcon from 'vue-material-design-icons/CircleOutline.vue'
import CircleHalfYearIcon from 'vue-material-design-icons/CircleSlice2.vue'
import CircleMonthIcon from 'vue-material-design-icons/CircleSlice4.vue'
import CircleWeekIcon from 'vue-material-design-icons/CircleSlice6.vue'
import CircleDayIcon from 'vue-material-design-icons/CircleSlice7.vue'
import OverdueIcon from 'vue-material-design-icons/BellCircleOutline.vue'
import HasAttachment from 'vue-material-design-icons/Attachment.vue';
import Checkmark from 'vue-material-design-icons/Check.vue';
import Alert from 'vue-material-design-icons/AlertCircleOutline.vue';
import MapIcon from 'vue-material-design-icons/Map.vue';
import VueContext from 'vue-context';
import {Server_URL, Server_URL_MAENGELMELDER} from "@/shared/utils";




export default {
  name: 'TourTableLight',
  components: {
    BookOpenPageVariantIcon, CheckBoldIcon, CurrencyEurIcon, CloseCircleIcon,
    HasAttachment, Checkmark, Alert, MapIcon, VueContext,
    CircleYearIcon, CircleHalfYearIcon, CircleMonthIcon, CircleWeekIcon, CircleDayIcon, OverdueIcon
  },
  props:{
    tableData: {
      type: Array,
      default: () => []
    },
  },
  mounted() {
  },
  data: () => {
    return {
      sortBy: '',
      sortDesc: false,
      fields: [
        {key: 'gi_auf_ext', label: "Betreff", sortable: true},
        {key: 'gi_match', label: "Wo", sortable: true},
        {key: 'count_open', label: 'Verg.'},
        {key: 'completed', label: 'Erledigt'},

      ],
      currentPage: 1,
      perPage: 20,
      url: Server_URL,
      urlMm: Server_URL_MAENGELMELDER,
      currentClicked: null,
      indeterminate: false,
      allSelected: false,
    }
  },
  computed: {
    rows() {
      return this.tableData.length
    },
  },
  methods: {
    calcSize(field) {
      if (field === 'selected') {
        return '36px';
      } else {
        return 'initial';
      }
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    formateMemo(value) {
      if (value === null) {
        return "";
      }
      if (value.length > 80)
        return value.substring(0,80) + '...';
      else
        return value;
    },
    responseError(response) {
      console.log(response)
    },
    gpsLink(item) {
      let url =  Server_URL_MAENGELMELDER + "/#/location/show?lat="+item.lat+"&lon="+item.lon;
      window.open(url, '_blank').focus();

    },
  }
}
</script>

<style scoped>


.h-1px {
  height: 1px;
}

.icon-def-grey {
  color: #5f6368;
}

.icon-def-green {
  color: green;
}

::v-deep .table td {
  padding: 0.15rem 0.75rem !important;
}

::v-deep table.b-table > tbody > tr.b-table-details > td {
  border-top: none !important;
  padding: 0px !important;
}

::v-deep .table.b-table>thead>tr>th[aria-sort]:before {
  float: none !important;
  margin-left: 0 !important;
  margin-right: 0.5em !important;
  font-size: larger;
}

::v-deep .table thead th {
  white-space: nowrap;
}

</style>

